
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class StatsList extends Vue {
  get stats() {
    return [
      {
        headerInfo: this.$t('components.nodes.statsList.100'),
        primaryText: this.$t('components.nodes.statsList.everyTitle'),
        supportingText: this.$t('components.nodes.statsList.liveIn'),
      },
      {
        headerInfo: this.$t('components.nodes.statsList.2Billion'),
        primaryText: this.$t('components.nodes.statsList.in2021'),
        supportingText: this.$t('components.nodes.statsList.ownership'),
      },
      {
        headerInfo: '38,000',
        primaryText: this.$t('components.nodes.statsList.onAverage'),
        supportingText: this.$t('components.nodes.statsList.gamesMusicFun'),
      },
    ];
  }
}
